import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import PartnerLandingPage from '@/components/Partners/PartnerLandingPage';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { WEBSITE_URL } from '@/shared/constants';
import { logPageView } from '@/lib/service';

const PietraPartners = ({}: NextPageWithLayout<any>) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'List Your Products & Services And Get Free Leads',
    });
  }, []);
  return <PartnerLandingPage />;
};

PietraPartners.getLayout = (page: React.ReactElement) => {
  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>List Your Products & Services And Get Free Leads</h1>
      <h2>Do less work. Get more customers.</h2>
      <h3>Set up your profile</h3>
      <h3>List your private label products</h3>
      <h3>Accept creator manufacturing requests</h3>
      <h3>Connect With Creators In One Centralized Portal</h3>
    </div>
  );
  return (
    <>
      <CustomHead
        title="Pietra Partners"
        description="Want to power the next generation of creative businesses? Join Pietra's Partner Network and help innovators launch their brands."
        url={`${WEBSITE_URL}/pietra-partners`}
      />
      <Layout structured={SEO_META[SEO_META_PAGES.PIETRA_PARTNERS].jsonld()}>
        {invisibleHeaderTags}
        {page}
      </Layout>
    </>
  );
};

export default PietraPartners;
